import environment from '../config/environment'

const algoliasearch =  require('algoliasearch')(environment.algolia.project, environment.algolia.token)
export default algoliasearch
